import { companyList, informationList } from '@/axios/market'

const marketList = {
  state: {
    marketList: [],
    informationList: []
  },
  mutations: {
    SET_MARKETLIST (state, marketList) {
      state.marketList = marketList
    }
  },
  actions: {
    MARKETLIST ({ commit }, params) {
      companyList(params).then(res => {
        this.state.marketList = res.data.data
      })
    },
    INFORMATIONLIST ({ commit }, params) {
      informationList(params).then(res => {
        this.state.marketList = res.data.data
      })
    }
  }
}

export default marketList



// WEBPACK FOOTER //
// ./src/store/modules/getMarketList.js